import React from "react";

export default props => (
<div className="test-page-content-inner test-page-test-intro">
    {renderItems(props.step, props.content.elems)}
</div>
);

function renderItems(step, elems) {
    return elems.map(function (elem, index) {
        return renderItem(step, elem, index);
    });
}

function renderItem(step, elem, index) {
    const key = `${step.toString()}-${index.toString()}`;

    switch (elem.type) {
    case "h1":
        return <h1 key={key}>{renderIcon(step, elem.icon)}<span key={`t-${step.toString()}`}>{elem.text.toUpperCase()}</span></h1>;
    case "h2":
        return <h2 key={key}>{elem.text}</h2>;
    case "p":
        return <p key={key}>{elem.text}</p>;
    case "g":
        return <MessagesList key={key} elems={elem.elems} />;
    case "img":
        return <img key={key} alt="" src={'/images/' + elem.src} width={elem.width} height={elem.height} />;
    default:
        return null;
    }
}

function renderIcon(step, icon) {
    if (icon) {
        return <i key={`i-${step.toString()}`} className={icon} />;
    }

    return <i key="i-0" />;
}

function MessagesList(props) {
    const items = props.elems.map((elem, index) =>
        <p key={index}>{elem.text}</p>
    );
    return (
        <div className="test-page-welcome-messages">{items}</div>
    );
}
